<template>
    <div v-if="visible" class="enlarge-modal" @click.self="$emit('close')">
      <div class="enlarge-content">
        <img :src="image" alt="Enlarged Receipt" />
        <button class="close-btn" @click="$emit('close')">×</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "EnlargeImageModal",
    props: {
      visible: { type: Boolean, default: false },
      image: { type: String, default: "" }
    }
  };
  </script>
  
  <style scoped>
  .enlarge-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  overflow: auto; /* allows scrolling if image too large */
  padding: 20px;
}

.enlarge-content {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.enlarge-content img {
  max-width: 100%;
  max-height: 100vh; /* make image fit screen height */
  object-fit: contain;
  border-radius: 10px;
}
  
  
  
  .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: #fff;
    color: #333;
    font-size: 20px;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    width: 32px;
    height: 32px;
    line-height: 28px;
    text-align: center;
  }
  </style>